import { SxProps, Theme } from '@mui/material';
import { TONE_COLOR_BY_KEY } from '../shared/toneColors';
import { CollectionEmailSendListItem, CollectionEmailSendStatus, CollectionEmailType } from './model';

export const MODULE_COLOR_BY_KEY: Record<CollectionEmailType, string> = {
  collection: '#96052F',
  statement: '#424E7A',
};

export const SOURCE_COLOR_BY_KEY = {
  automatic: '#2e7d32',
  manual: '#1565c0',
  one_off: '#6a1b9a',
} as const;

type ChipVariant = 'filled' | 'outlined';

interface EmailHistoryChipStyle {
  variant: ChipVariant;
  sx?: SxProps<Theme>;
}

const outlinedColorSx = (color: string): SxProps<Theme> => ({
  borderColor: color,
  color,
});

const filledColorSx = (color: string): SxProps<Theme> => ({
  bgcolor: color,
  color: '#fff',
  '& .MuiChip-label': { color: '#fff' },
});

export const STATUS_CHIP_COLOR: Record<CollectionEmailSendStatus, 'success' | 'error' | 'default'> = {
  sent: 'success',
  failed: 'error',
  queued: 'default',
};

export const getModuleChipStyle = (emailType: CollectionEmailType): EmailHistoryChipStyle => ({
  variant: 'outlined',
  sx: outlinedColorSx(MODULE_COLOR_BY_KEY[emailType]),
});

export const getToneChipStyle = (row: Pick<CollectionEmailSendListItem, 'tone'>): EmailHistoryChipStyle => {
  if (!row.tone) {
    return { variant: 'outlined' };
  }

  return {
    variant: 'filled',
    sx: filledColorSx(TONE_COLOR_BY_KEY[row.tone]),
  };
};

export const getSourceChipStyle = (
  row: Pick<CollectionEmailSendListItem, 'one_off' | 'send_source'>,
): EmailHistoryChipStyle => {
  const sourceKey = row.one_off ? 'one_off' : row.send_source;

  return {
    variant: 'outlined',
    sx: outlinedColorSx(SOURCE_COLOR_BY_KEY[sourceKey]),
  };
};
